import { TradingRepo as tradingRepo } from '@services/trading.repo';
import { StringUtilities as stringUtilities } from '@common/string.utilities';
import { TradeSet } from '@models/trading/tradeSet';
import { DateFilter } from '@models/trading/dateFilters';
import { AuthService as authService } from "@common/auth.service";
import { extractErrorMessage } from "@common/utils/errorUtils";

class PortfolioTradeSetsController implements angular.IOnInit{

  public pendingTradeSets: Array<any>;
  public finalisedTradeSets: Array<any>;
  public completedTradeSets: Array<any>;
  public isLoading: boolean;
  public loadPortfolioTrades;
  public tradeSetOwners: string[] =[]
  public tradeSheetOwner: string;

  public displayAllTrades: boolean = false;

  private selectedFilter: DateFilter;
  public searchFiltersList: Array<DateFilter>;
  public fromDate ;
  public toDate;
  public loadTradeSheets;

  /** @ngInject */
  constructor(private tradingRepo: tradingRepo, private $window: angular.IWindowService,
    private notifyjs, private $mdDialog: angular.material.IDialogService,
    private $rootScope: angular.IRootScopeService, private authService: authService) { }

  $onInit() {
    this.getTradeSummaries();
  }

  $onChanges(changes) {
    if (changes.fromDate || changes.toDate ) {
        this.getTradeSummaries()
    }
  }

  public getShortName(text: string) {
    return stringUtilities.truncateText(text, 20);
  }

  getTradeSummaries() {
    this.isLoading = true;
    this.tradingRepo.getTradeSummary(this.fromDate, this.toDate, this.displayAllTrades)
      .then(res => {
        this.pendingTradeSets = [];
        this.finalisedTradeSets = [];
        this.completedTradeSets = [];

        const tradeOwners = new Set<string>();
        let tradeSets = res.data as Array<any>;
        tradeSets.sort((ts1, ts2) => ts1.clientName > ts2.clientName ? 1 : -1);
        tradeSets.forEach(ts => {
          tradeOwners.add(ts.owner)
          if (ts.tradeSheet == null) {
            this.pendingTradeSets.push(ts);
          }
          else if (ts.tradeSheet.dateClosed == null) {
            this.finalisedTradeSets.push(ts);
          }
          else {
            this.completedTradeSets.push(ts);
          }
        });

        this.tradeSetOwners = Array.from(tradeOwners);
      })
      .catch(err => this.notifyjs(extractErrorMessage(err)))
      .finally(() => this.isLoading = false);
  }

  filterTradeSets(filter) {
    this.selectedFilter.active = false;
    filter.active = true;
    this.selectedFilter = filter;

    this.getTradeSummaries();
  }

  deleteTradeSet($event, tradeSet: TradeSet) {
    // Prevent row from expanding on actions
    $event.stopPropagation();

    // Cancel the tradeSheet
    let that = this;
    const tempScope = that.$rootScope.$new(true) as any;
    tempScope.tradeSet = tradeSet;
    that.$mdDialog.show(
      this.$mdDialog.confirm()
        .clickOutsideToClose(true)
        .title('Warning')
        .textContent(`Are you sure you want to remove Portfolio trades set #${tradeSet.tradeSetId}?`)
        .theme('primary ')
        .ok('Yes')
        .cancel('Cancel')
    ).then(
      // This code runs when confirm is clicked.
      () => {
        that.isLoading = true;
        that.tradingRepo.deleteTradeSet(tradeSet.tradeSetId)
          .then(
            (res) => { that.getTradeSummaries(); }
          ).catch(err => {
            this.notifyjs(extractErrorMessage(err));
          }
          ).finally(() => {
            that.isLoading = false;
          });

      }

    );
  }

  generateTradeSheet() {
    this.executeGenerateTradeSheet();
  }

  private executeGenerateTradeSheet() {
    const tradeSetIds = this.pendingTradeSets.filter(ts => ts.selected).map(ts => ts.tradeSetId);
    this.isLoading = true;

    this.tradingRepo.getAllTradeSetSecurities(tradeSetIds)
      .then(res => {
        const tradeSetSecurities = res.data;
        const tempScope = this.$rootScope.$new(true) as any;
        tempScope.tradeSetSecurities = tradeSetSecurities;

        this.isLoading = false;

        return this.$mdDialog.show({
          template: '<trade-validity trade-set-securities="tradeSetSecurities"></trade-validity>',
          scope: tempScope
        });
      })
      .then(tradeUrls => {
        if (!tradeUrls.length){
          return;
        };

        // console.log("tradeUrls", tradeUrls);


        // tradeUrls.forEach(url => this.$window.open(url, '_blank'));

        this.getTradeSummaries();
        this.loadTradeSheets = true
      })
      .catch(err => this.isLoading = false);
  }

  showTrades(tradeSet: any) {
    if (!tradeSet.trades) {
      this.isLoading = true;
      this.tradingRepo.getTradePreview(tradeSet.tradeSetId)
        .then(res => {
          tradeSet.trades = res.data as Array<any>;
          tradeSet.trades.sort((ts1, ts2) => ts1.security.name > ts2.security.name ? 1 : -1);
          tradeSet.show = true;
        })
        .catch(err => this.notifyjs(extractErrorMessage(err)))
        .finally(() => this.isLoading = false);
    }
    else {
      tradeSet.show = !tradeSet.show;
    }
  }
}

export const portfolioTradeSets: angular.IComponentOptions = {
  template: require('./portfolioTradeSets.html'),
  controller: PortfolioTradeSetsController,
  bindings: {
    isLoading: '<',
    loadPortfolioTrades: '<',
    fromDate : '<',
    toDate : '<',
    loadTradeSheets : '='
  }
};



// WEBPACK FOOTER //
// ./src/app/trading/portfoliotradesets/portfolioTradeSets.ts